const topics = [
  {
    title: '顶流塌房全记录',
    desc: '盘点近三年娱乐圈顶流艺人塌房事件，从时间线到后续影响，51黑料吃瓜网为你带来最完整梳理。涉及税务、感情、合约等多重维度深度解析。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20collage%20illustration%20of%20entertainment%20scandals%20and%20breaking%20news%2C%20warm%20orange%20and%20deep%20coral%20gradient%2C%20newspaper%20fragments%20floating%2C%20modern%20editorial%20style%2C%20clean%20composition%2C%20dramatic%20yet%20minimal%20design&width=900&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '综艺背后的暗流',
    desc: '热门综艺节目背后那些不为人知的博弈与内幕，从选手淘汰到评委争议，一一揭开真人秀的"真人"面纱。51吃瓜在线观看独家专题。',
    tag: '独家揭秘',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20show%20behind%20scenes%20illustration%2C%20warm%20amber%20and%20soft%20pink%20palette%2C%20camera%20and%20spotlight%20motifs%2C%20modern%20minimal%20art%2C%20clean%20geometric%20shapes%2C%20editorial%20composition&width=900&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    title: '直播带货翻车合集',
    desc: '从头部主播到明星跨界，盘点直播带货领域那些轰动一时的翻车事件。质量问题、虚假宣传、售后纠纷……吃瓜在线视频完整合集。',
    tag: '热门合集',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20live%20streaming%20commerce%20illustration%2C%20shopping%20cart%20with%20warning%20symbols%2C%20warm%20coral%20and%20cream%20gradient%2C%20modern%20flat%20design%2C%20clean%20lines%2C%20editorial%20style%2C%20soft%20atmosphere&width=900&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    title: '2025娱乐圈年中盘点',
    desc: '半年已过，娱乐圈发生了哪些值得铭记的大事？从结婚离婚到翻红翻车，这份年中盘点带你一次性回顾51黑料在线观看所有热门事件。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20year%20review%20illustration%20with%20calendar%20and%20headline%20elements%2C%20warm%20orange%20and%20rose%20color%20scheme%2C%20timeline%20motif%2C%20modern%20minimal%20style%2C%20clean%20geometric%20composition%2C%20editorial%20design&width=900&height=400&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            深度追踪，全面解读
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/50 rounded-xl overflow-hidden hover:border-accent-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={topic.image}
                  alt={topic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="900"
                  height="400"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  {topic.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-accent-500 transition-colors">
                  {topic.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {topic.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}